import type {
	ArtistFormData,
	LabelFormData,
	ManagerFormData,
	ProviderFormData,
} from './types';
import {ClaimAccessType, ClaimScreen} from './types';

export const defaultArtistFormData: ArtistFormData = {
	artistUpc: '',
	facebook: '',
	instagram: '',
	twitter: '',
	website: '',
};

export const defaultProviderFormData: ProviderFormData = {
	providerUpc1: '',
	providerUpc2: '',
};

export const defaultManagerFormData: ManagerFormData = {
	managerArtists: [],
};

export const defaultLabelFormData: LabelFormData = {
	labelSubLabels: [],
};

export const ClaimFlow: {
	[key in ClaimScreen]: {
		previous?: ClaimScreen;
		next?: ClaimScreen;
		hash: string;
		type?: ClaimAccessType;
	};
} = {
	[ClaimScreen.SELECT_CLAIM_TYPE]: {
		hash: '#select_type',
	},
	[ClaimScreen.NEW_ARTIST]: {
		previous: ClaimScreen.SELECT_CLAIM_TYPE,
		next: ClaimScreen.ARTIST_SOCIALS,
		hash: '#artist_1',
		type: ClaimAccessType.ARTIST,
	},
	[ClaimScreen.ARTIST_SOCIALS]: {
		previous: ClaimScreen.NEW_ARTIST,
		next: ClaimScreen.ARTIST_DISCOGRAPHY_LIVE,
		hash: '#artist_2',
		type: ClaimAccessType.ARTIST,
	},
	[ClaimScreen.ARTIST_DISCOGRAPHY_LIVE]: {
		previous: ClaimScreen.ARTIST_SOCIALS,
		next: ClaimScreen.ARTIST_DISCOGRAPHY_TAKEDOWN,
		hash: '#artist_3_live',
		type: ClaimAccessType.ARTIST,
	},
	[ClaimScreen.ARTIST_DISCOGRAPHY_TAKEDOWN]: {
		previous: ClaimScreen.ARTIST_DISCOGRAPHY_LIVE,
		hash: '#artist_4_takedown',
		type: ClaimAccessType.ARTIST,
	},
	[ClaimScreen.NEW_PROVIDER]: {
		previous: ClaimScreen.SELECT_CLAIM_TYPE,
		hash: '#provider_1',
		type: ClaimAccessType.PROVIDER,
	},
	[ClaimScreen.MANAGER_ARTIST_LIST]: {
		previous: ClaimScreen.SELECT_CLAIM_TYPE,
		hash: '#manager_artist_list',
		type: ClaimAccessType.MANAGER,
	},
	[ClaimScreen.MANAGER_ADD_ARTIST]: {
		previous: ClaimScreen.MANAGER_ARTIST_LIST,
		hash: '#manager_add_artist',
		type: ClaimAccessType.MANAGER,
	},
	[ClaimScreen.MANAGER_EDIT_ARTIST]: {
		previous: ClaimScreen.MANAGER_ARTIST_LIST,
		hash: '#manager_edit_artist',
		type: ClaimAccessType.MANAGER,
	},
	[ClaimScreen.LABEL_LIST]: {
		previous: ClaimScreen.SELECT_CLAIM_TYPE,
		hash: '#label_list',
		type: ClaimAccessType.LABEL,
	},
	[ClaimScreen.LABEL_ADD]: {
		previous: ClaimScreen.LABEL_LIST,
		hash: '#label_add',
		type: ClaimAccessType.LABEL,
	},
	[ClaimScreen.LABEL_EDIT]: {
		previous: ClaimScreen.LABEL_LIST,
		hash: '#label_edit',
		type: ClaimAccessType.LABEL,
	},
};

export const ClaimFormReverseHashMap = Object.entries(ClaimFlow).reduce<{
	[key: string]: ClaimScreen;
}>((acc, [screen, value]) => {
	acc[value.hash] = screen as unknown as ClaimScreen;
	return acc;
}, {});
